import { defineStore } from "pinia";

export default defineStore("userState", {
  state: () => ({
    id: null,
    unirId: null,
    email: "",
    userRole: [],
    userName: null,
  }),
  getters: {
    isAdmin: (state) =>
      state.userRole.includes("ROLE_ADMIN") ||
      state.userRole.includes("ROLE_TEACHER"),
    isTutor: (state) => state.userRole.includes("ROLE_TUTOR"),
    isStudent: (state) => state.userRole.includes("ROLE_STUDENT"),
  },
  actions: {
    setUser(user) {
      this.id = user.id;
      this.unirId = user.unirId;
      this.email = user.email;
      this.userRole = user.userRole;
      this.userName = user.userName;
    },
    clearUser() {
      this.id = null;
      this.unirId = null;
      this.email = "";
      this.userRole = [];
      this.userName = null;
    },
  },
});
